import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';

// Define the validation schema using Yup
const validationSchema = Yup.object({
  rudrakshName: Yup.string().matches(/^\S.*$/, 'No leading spaces allowed').required('Rudraksh type is required'),
  unitPrice: Yup.number().positive('Price must be positive').required('Unit price is required'),
  size: Yup.string().matches(/^\S.*$/, 'No leading spaces allowed').required('Size is required'),
  quantity: Yup.number().integer('Quantity must be an integer').min(1, 'Quantity must be greater than 0').required('Quantity is required'),
  weight: Yup.number().positive('Weight must be positive').required('Weight is required'),
});

const AddRudrakshForm = ({ handleRudrakshSubmit }) => {
  const handleSubmit = (values, { resetForm }) => {
    // Send rudraksh data to the parent component
    handleRudrakshSubmit(values);

    // Reset the form
    resetForm();
    alert('Rudraksh successfully added!');
  };

  return (
    <div className="dynamic-fields">
      <Formik
        initialValues={{
          rudrakshName: '',
          unitPrice: '',
          size: '',
          quantity: '',
          weight: '',
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm>
            {/* Rudraksh Type and Unit Price */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formRudrakshName">
                  <Form.Label>Rudraksh Type :</Form.Label>
                  <Field as="select" name="rudrakshName" className="form-control" style={{ height: 'auto', overflowY: 'scroll' }}>
                    <option value="">Select type</option>
                    <option value="1 mukhi">1 mukhi</option>
                    <option value="2 mukhi">2 mukhi</option>
                    <option value="3 mukhi">3 mukhi</option>
                    <option value="4 mukhi">4 mukhi</option>
                    <option value="5 mukhi">5 mukhi</option>
                    <option value="6 mukhi">6 mukhi</option>
                    <option value="7 mukhi">7 mukhi</option>
                    <option value="8 mukhi">8 mukhi</option>
                    <option value="9 mukhi">9 mukhi</option>
                    <option value="10 mukhi">10 mukhi</option>
                    <option value="11 mukhi">11 mukhi</option>
                    <option value="12 mukhi">12 mukhi</option>
                    <option value="13 mukhi">13 mukhi</option>
                    <option value="14 mukhi">14 mukhi</option>
                  </Field>
                  <ErrorMessage name="rudrakshName" component="div" className="text-danger" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formUnitPrice">
                  <Form.Label>Unit Price :</Form.Label>
                  <Field type="text" name="unitPrice" className="form-control" />
                  <ErrorMessage name="unitPrice" component="div" className="text-danger" />
                </Form.Group>
              </Col>
            </Row>
            {/* Size and Weight */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formSize">
                  <Form.Label>Size :</Form.Label>
                  <Field type="text" name="size" className="form-control" />
                  <ErrorMessage name="size" component="div" className="text-danger" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formWeight">
                  <Form.Label>Weight :</Form.Label>
                  <Field type="text" name="weight" className="form-control" />
                  <ErrorMessage name="weight" component="div" className="text-danger" />
                </Form.Group>
              </Col>
            </Row>
            {/* Color and Quantity */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formQuantity">
                  <Form.Label>Quantity :</Form.Label>
                  <Field type="text" name="quantity" className="form-control" />
                  <ErrorMessage name="quantity" component="div" className="text-danger" />
                </Form.Group>
              </Col>
            </Row>
            {/* Submit Button */}
            <Row className="mb-3">
              <Col md={6}>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
              </Col>
            </Row>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default AddRudrakshForm;
